{
  "platform": {
    "leads": {
      "nav": "Leads",
      "navNew": "Leads, new: {{count}}",
      "title": "Leads",
      "subtitle": "Requests from the website's Book a Demo form. A lead is a prospect's contact details, not an organisation or a user.",
      "timeZone": "Times are shown in your time zone ({{timeZone}}).",
      "search": "Search by name, company, email, mobile or reference",
      "filters": {
        "title": "Filter leads",
        "status": "Status",
        "allStatuses": "All statuses",
        "received": "Received",
        "utcHint": "Days are counted in UTC."
      },
      "columns": {
        "received": "Received",
        "name": "Name",
        "email": "Work email",
        "mobile": "Mobile",
        "puRange": "Purchasing Units",
        "language": "Language",
        "page": "Page",
        "status": "Status",
        "assignee": "Assigned to"
      },
      "empty": "No demo requests yet.",
      "emptyHint": "Requests sent from the website's Book a Demo form appear here.",
      "emptyFiltered": "No lead matches this search or these filters.",
      "unassigned": "Unassigned",
      "companyNotProvided": "Not provided (earlier form)",
      "companyNotProvidedLine": "Company not provided (earlier form)",
      "status": {
        "new": "New",
        "contacted": "Contacted",
        "qualified": "Qualified",
        "closed": "Closed"
      },
      "puRange": {
        "1_5": "1–5",
        "6_10": "6–10",
        "11_20": "11–20",
        "21_30": "21–30",
        "30_plus": "30+",
        "not_sure": "Not sure"
      },
      "locale": {
        "en": "English",
        "ar": "Arabic"
      },
      "form": {
        "book_a_demo": "Book a Demo"
      },
      "testEnvironment": "Test environment — synthetic leads only",
      "notProduction": "Not the production environment",
      "realLeads": "Real enquiry data. Restricted access. Do not use these records for testing.",
      "environment": "Environment:",
      "event": {
        "received": "Request received",
        "statusChanged": "Status changed from {{from}} to {{to}}",
        "statusSet": "Status set to {{to}}",
        "noteAdded": "Internal note added",
        "assigned": "Assignment changed",
        "assignedTo": "Assigned to {{name}}",
        "unassigned": "Assignment removed",
        "other": "Update recorded",
        "websiteForm": "Website form",
        "system": "System"
      },
      "detail": {
        "contact": "Contact",
        "name": "Name",
        "company": "Company",
        "email": "Work email",
        "mobile": "Mobile",
        "mobileE164": "International format",
        "notDerived": "Not derived: the number did not start with + or 00",
        "enquiry": "Enquiry",
        "reference": "Reference",
        "received": "Received",
        "puRange": "Approximate number of Purchasing Units",
        "language": "Form language",
        "page": "Source page",
        "form": "Form",
        "noticeVersion": "Notice version",
        "notRecorded": "Not recorded",
        "followUp": "Status and assignment",
        "status": "Status",
        "assignee": "Assigned to",
        "you": "you",
        "history": "History",
        "historyHint": "Oldest first. Entries cannot be edited or removed.",
        "noHistory": "No history recorded."
      },
      "manage": {
        "newStatus": "New status",
        "chooseStatus": "Choose a status",
        "statusNote": "Note with this change",
        "statusNoteHint": "Kept in the history with the change. Internal only.",
        "updateStatus": "Update status",
        "statusUpdated": "Status updated: {{status}}.",
        "statusRequired": "Choose the new status.",
        "statusRefused": "The status was not changed",
        "notes": "Internal notes",
        "notesHint": "Seen by platform operators only, never by the prospect.",
        "note": "Internal note",
        "noteHint": "Up to 2000 characters. Added to the history; it cannot be edited later.",
        "addNote": "Add note",
        "noteAdded": "Note added.",
        "noteRequired": "Write the note before adding it.",
        "noteTooLong": "Keep the note to 2000 characters or fewer.",
        "noteRefused": "The note was not added",
        "assignToMe": "Assign to me",
        "removeAssignment": "Remove assignment",
        "assignedToYou": "Assigned to you.",
        "assignmentRemoved": "Assignment removed."
      },
      "email": {
        "title": "Email to the Fidelen team",
        "off": "The internal lead email is off in this environment.",
        "recipient": "Recipient",
        "attempts": "Attempts",
        "queuedAt": "Queued",
        "submittedAt": "Accepted",
        "failedAt": "Failed",
        "mailer": "Mail service",
        "testSink": "Test sink: discarded, not sent to a mailbox",
        "notProof": "That is not proof it arrived.",
        "outcomeUncertain": "Outcome uncertain: an attempt ended without a recorded result.",
        "state": {
          "pending": "Waiting to be sent",
          "sending": "Sending",
          "retrying": "Retry scheduled",
          "submitted": "Accepted by the mail service",
          "failed": "Failed"
        }
      },
      "crm": {
        "title": "CRM sync (Zoho)",
        "reason": "Reason",
        "attempts": "Attempts",
        "lastAttempt": "Last attempt",
        "syncedAt": "Synced",
        "recordId": "Zoho record ID",
        "newTab": "(opens in a new tab)",
        "state": {
          "pending": "Waiting to sync",
          "syncing": "Syncing",
          "synced": "Synced",
          "retry_scheduled": "Retry scheduled",
          "failed": "Failed",
          "needs_configuration": "Needs configuration",
          "matching_decision": "Matching decision needed",
          "reconciliation_required": "Check Zoho before creating again"
        },
        "error": {
          "not_configured": "Sync is switched off or not configured",
          "environment_guard": "Blocked: a test environment may not write to production Zoho",
          "organisation_mismatch": "Linked to a Zoho organisation or environment other than the configured one",
          "data_centre_mismatch": "Authorised in a Zoho data centre other than the configured one",
          "authorisation_revoked": "Authorisation revoked or expired: Zoho needs to be authorised again",
          "client_rejected": "Zoho refused the integration's client ID or secret",
          "authentication_rejected": "Zoho refused the access token, even after renewal",
          "scope_missing": "The Zoho authorisation lacks a permission this sync needs",
          "invalid_module": "Zoho does not recognise or allow the Leads module",
          "mandatory_field_missing": "Zoho requires a field this integration does not send",
          "invalid_field_value": "Zoho refused a field name or value",
          "record_rejected": "Zoho refused the record",
          "request_rejected": "Zoho refused the request",
          "duplicate_record": "Another Zoho record already holds this unique value",
          "external_id_mismatch": "Zoho's answer does not match this lead's ID",
          "rate_limited": "Zoho asked to slow down (rate limit)",
          "token_unavailable": "No Zoho access token could be issued just now",
          "provider_unavailable": "Zoho answered with a server error",
          "connection_failed": "The connection to Zoho failed or timed out",
          "unexpected_response": "Zoho's answer could not be read",
          "worker_failed": "The attempt failed inside Fidelen",
          "outcome_unknown": "Zoho's answer was lost: Fidelen did not send it again until someone checks Zoho",
          "reference_ambiguous": "More than one Zoho lead carries this Fidelen reference",
          "reference_mismatch": "The Zoho lead with this reference has a different email",
          "unreachable": "Zoho could not be reached; nothing was sent",
          "company_missing": "This lead has no company (earlier form) and Zoho requires one, so nothing was sent; no placeholder is used",
          "owner_unverified": "The configured Zoho lead owner is not verified as an active user, so writes are blocked"
        },
        "nextAttempt": "Next attempt",
        "resolution": "Resolved",
        "resolutionValue": {
          "reconciled": "Found in Zoho on a later check",
          "linked": "Linked to an existing Zoho lead after a check",
          "create_confirmed": "Created after a check in Zoho"
        }
      }
    }
  }
}
